import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { RouteConfig } from 'vue-router';
import { asyncRoutes, constantRoutes } from '@/router';
import store from '@/store';

/** document hooks */
const hasPermission: any = (roles: string[], route: RouteConfig): any => {
	// 某些菜单是有某种角色才出现的
	if (route.meta && route.meta.roles) {
		return roles.some((role: any): any => route.meta.roles.includes(role));
	}

	return true;
};

/** 过滤原始路由 */
export const filterAsyncRoutes: any = (routes: RouteConfig[], roles: string[]): any => {
	const res: RouteConfig[] = [];
	routes.forEach((route: any): any => {
		const r: any = { ...route };

		if (hasPermission(roles, r)) {
			if (r.children) {
				r.children = filterAsyncRoutes(r.children, roles);
			}

			res.push(r);
		}
	});

	return res;
};

/** 过滤权限路由 */
export const filterPermissionRoutes: any = (navMenus: Array<any>, accessedRoutes: Array<RouteConfig>): any => {
	const res: RouteConfig[] = [];

	for (let index = 0; index < accessedRoutes.length; index++) {
		// 拿出每个动态路由
		const element: RouteConfig = accessedRoutes[index];
		// 判断路由是否在用户的菜单权限中
		const filterEle: RouteConfig = generateAccessElement(navMenus, element);
		if (filterEle) {
			res.push(filterEle);
		}
	}

	return res;
};

/** 过滤子菜单
 * 判断路由是不是在用户菜单中
 */
export const generateAccessElement: any = (navMenus: Array<any>, routeItem: RouteConfig): any => {
	// 去掉/
	const matchPath: string = routeItem.path.replace('/', '');
	const matchCode: string = routeItem.meta.code;
	let matchItem: any = '';
	// 查找外层子菜单是否匹配
	for (let index = 0; index < navMenus.length; index++) {
		const element = navMenus[index];
		// 如果是在存在的路由
		if (element.value === matchCode) {
			// 获取匹配的路由
			matchItem = routeItem;
			// 匹配路由的子节点
			const routeItemList: Array<RouteConfig> = routeItem.children || [];
			const routeItemAddedList: Array<RouteConfig> = [];
			for (let indexChildren = 0; indexChildren < routeItemList.length; indexChildren++) {
				// 子节点的每一项
				const elementChildrenItem: RouteConfig = routeItemList[indexChildren];

				// 添加父容器标记
				// let elementChildrenPath: string = '';
				// if (elementChildrenItem.path.indexOf(`/${element.value}/`) !== -1) {
				// 	elementChildrenPath = elementChildrenItem.path;
				// } else {
				// 	elementChildrenPath = `/${element.value}/${elementChildrenItem.path}`;
				// }

				const elementChildrenCode: string = elementChildrenItem.meta.code;
				// 查找当前子菜单是否在权限子菜单内
				if (element.childMenu && element.childMenu.length) {
					for (let indexSub = 0; indexSub < element.childMenu.length; indexSub++) {
						const elementSub = element.childMenu[indexSub];

						// elementChildrenItem.path == materialCategoryManagement
						// elementSub.value == /material/materialCategoryManagement
						if (elementChildrenCode === elementSub.value) {
							routeItemAddedList.push(elementChildrenItem);
						}
					}
				}

				// 添加隐藏内容
				if (elementChildrenItem.meta && elementChildrenItem.meta.hidden) {
					routeItemAddedList.push(elementChildrenItem);
				}
			}

			// 重新赋子菜单
			if (routeItemAddedList.length) {
				routeItem.children = routeItemAddedList;
			} else {
				delete routeItem.children;
			}
		}
	}

	return matchItem;
};

/** document hooks */
export interface IPermissionState {
	routes: RouteConfig[];
	dynamicRoutes: RouteConfig[];
}

/** document hooks */
@Module({
	dynamic: true,
	store,
	name: 'permission'
})
class Permission extends VuexModule implements IPermissionState {
	/** document hooks */
	public routes: RouteConfig[] = [];

	/** document hooks */
	public dynamicRoutes: RouteConfig[] = [];

	/** 从后端获取到的路由 */
	public requestPermissionList: RouteConfig[] = [];

	/** 同步修改requestRouterList的值 */
	@Mutation
	private SET_REQUEST_PERMISSION_LIST(routes: any): void {
		this.requestPermissionList = routes;
	}

	/** document hooks */
	@Mutation
	private SET_ROUTES(routes: RouteConfig[]): any {
		this.routes = constantRoutes.concat(routes);
		this.dynamicRoutes = routes;
		// console.log('set routess.');
	}

	/** document hooks */
	@Action
	public generateRoutes(roles: string[] = []): any {
		let accessedRoutes: any = '';
		if (roles.includes('admin')) {
			accessedRoutes = asyncRoutes;
		} else {
			accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
		}

		console.log('动态路由数据 generater routes::', permissionModule.dynamicRoutes);

		this.SET_ROUTES(accessedRoutes);
	}

	/** 依据权限过滤路由 */
	@Action
	public filterRoutes(navMenus: string[] = []): any {
		this.SET_REQUEST_PERMISSION_LIST(navMenus);
		const accessedRoutes: Array<any> = filterAsyncRoutes(asyncRoutes, []);

		// test start
		// const displayRoutes = accessedRoutes;
		// test end
		const displayRoutes: Array<any> = filterPermissionRoutes(navMenus, accessedRoutes);

		// console.log('动态路由数据navMenus::', navMenus);
		// console.log('动态路由数据accessRoutes::', accessedRoutes);
		// console.log('生成的路由数据::', displayRoutes);
		console.log(asyncRoutes, '路由数据=====');

		this.SET_ROUTES(asyncRoutes);
		// this.SET_ROUTES(displayRoutes);
	}
}

/** document hooks */
export const permissionModule: any = getModule(Permission);
